<template>
  <a-modal
    centered
    v-model="visible"
    title="超时收费标准"
    :width="800"
    :destroyOnClose="true"
    :maskClosable="false"
    @ok="onSubmit"
    :confirmLoading="confirmLoading"
  >
    <div style="margin-bottom:10px">
      时间单位：<a-select
        style="width:100px"
        v-model="timeUnit"
        @change="changeTimeUnit"
      >
        <a-select-option
          v-for="el in timeUnitData"
          :value="el.Id"
          :key="el.Id"
          >{{ el.Text }}</a-select-option
        >
      </a-select>
      <a-button style="float:right" icon="plus" @click="add">新增</a-button>
    </div>
    <a-spin :spinning="spinning">
      <div class="stardard-table">
        <table>
          <tr>
            <th>时长</th>
            <th>时间单位</th>
            <th>收费类型</th>
            <th>收费值</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in tableData" :key="index">
            <td>
              <a-input-number
                v-model="item.TimeValue"
                class="inner-txt"
                :precision="0"
                :min="0"
              ></a-input-number>
            </td>
            <td>【{{ item.TimeUnitName }}】 以内</td>
            <td>
              按
              <a-select
                default-value="0"
                class="inner-txt"
                v-model="item.ChargingType"
              >
                <a-select-option value="0">
                  固定值
                </a-select-option>
                <a-select-option value="1">
                  比例
                </a-select-option>
              </a-select>
            </td>
            <td>
              收费
              <a-input-number
                v-model="item.ChargingValue"
                class="inner-txt"
                :min="0"
                :precision="0"
              ></a-input-number>
              <em v-if="item.ChargingType == 0"> 元</em>
              <em v-if="item.ChargingType == 1"> % 房费</em>
            </td>
            <td>
              <a-button type="link" size="small" @click="delRow(index)"
                >删除</a-button
              >
            </td>
          </tr>
        </table>
      </div>
    </a-spin>
  </a-modal>
</template>
<script>
export default {
  name: "ChargingStandard",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      tableData: [],
      spinning: false,
      timeUnitData: [
        {
          Id: 0,
          Text: "分钟"
        },
        {
          Id: 1,
          Text: "小时"
        }
      ],
      priceCodeId: "",
      timeUnit: 0,
      timeUnitName: "分钟"
    };
  },
  created() {},
  methods: {
    show(id) {
      this.priceCodeId = id;
      this.timeUnit = 0;
      this.timeUnitName = "分钟";
      this.tableData = [];
      this.visible = true;
      this.spinning = true;
      this.$post("GetChargingStandard", { Id: id }).then(res => {
        if (res.Data && res.Data.length) {
          this.timeUnit = res.Data[0].TimeUnit;
          this.tableData = res.Data.map(v => {
            v.ChargingType = String(v.ChargingType);
            const result = this.timeUnitData.find(el => el.Id == v.TimeUnit);
            v.TimeUnitName = result ? result.Text : "";
            this.timeUnitName = v.TimeUnitName;
            return v;
          });
        }
        this.spinning = false;
      });
    },
    changeTimeUnit(val) {
      const result = this.timeUnitData.find(el => el.Id == val);
      this.timeUnitName = result ? result.Text : "";
      this.tableData.forEach(el => {
        el.TimeUnit = val;
        el.TimeUnitName = this.timeUnitName;
      });
    },
    add() {
      this.tableData.push({
        TimeUnit: this.timeUnit,
        TimeUnitName: this.timeUnitName,
        TimeValue: "",
        ChargingType: "0",
        ChargingValue: ""
      });
    },
    delRow(index) {
      this.tableData.splice(index, 1);
    },
    onSubmit() {
      if (this.tableData && this.tableData.length) {
        this.tableData = this.tableData.filter(el => {
          delete el.TimeUnitName;
          return el.TimeValue;
        });
      }
      const params = {
        PriceCodeId: this.priceCodeId,
        Details: this.tableData
      };
      this.$post("SetChargingStandard", params).then(() => {
        this.$message.success("操作成功");
        this.$emit("update");
        this.visible = false;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.stardard-table {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  table {
    width: 100%;
    border: 1px solid #eee;
  }

  th {
    background: #efefef;
  }
  th,
  td {
    padding: 3px 5px;
    border-bottom: 1px solid #eee;
    text-align: left;
    em {
      font-style: normal;
    }
    .inner-txt {
      width: 100px;
    }
  }
}
</style>
